import type { NuxtUseScriptInput, NuxtUseScriptOptions } from "#nuxt-scripts";

export function useExponeaScript(scriptOptions?: NuxtUseScriptOptions) {
  if (!import.meta.client) return;

  const publicRuntimeConfig = useRuntimeConfig().public;

  const exponeaScriptSource =
    publicRuntimeConfig.assetBaseUrl + "/static/exp.js";

  const exponeaProjectToken = getProjectToken(
    publicRuntimeConfig.appRegion,
    publicRuntimeConfig.appEnvironment
  );

  const safariWebPushID = getSafariWebPushID(
    publicRuntimeConfig.appRegion,
    publicRuntimeConfig.appEnvironment
  );

  const authStore = useAuthStore();
  const { user, guest } = storeToRefs(authStore);

  const customerId = ref<string | null>(null);

  customerId.value = user.value?.id
    ? user.value.id
    : guest.value?.id
    ? guest.value.id
    : null;

  const baseConfig: NuxtUseScriptInput = {
    src: exponeaScriptSource,
    id: "exponea-script",
    fetchpriority: "low",
    tagPriority: "low",
    "data-exponea-token": exponeaProjectToken,
    "data-push-id": safariWebPushID,
  };

  if (customerId.value) baseConfig["data-customer-id"] = customerId.value;

  const exponeaScript = useScript(baseConfig, scriptOptions);

  return exponeaScript;
}

function getProjectToken(appRegion: string, appEnvironment: string) {
  if (appRegion === "NL") {
    if (appEnvironment === "production")
      return "b89a8b84-effe-11ed-94db-f2ce2b1c0c50"; // NL - Prod
    else return "6e4e4b24-effe-11ed-9786-f2ce2b1c0c50"; // NL - Development
  }
  if (appRegion === "BE") {
    if (appEnvironment === "production")
      return "e839e5ce-effe-11ed-a3f5-1abf3d812102"; // BE - Prod
    else return "d11b0bc0-effe-11ed-8c97-1abf3d812102"; // BE - Development
  }
}

function getSafariWebPushID(appRegion: string, appEnvironment: string) {
  if (appRegion === "NL") {
    if (appEnvironment === "production") return "web.dev.toolstation.prod.nl";
    else return "web.dev.toolstation.pre-prod.nl";
  }
  if (appRegion === "BE") {
    if (appEnvironment === "production") return "web.dev.toolstation.prod.be";
    else return "web.dev.toolstation.pre-prod.be";
  }
}
